import { useQuery } from "@tanstack/react-query";

import { getProjectsProjectIDDocuments } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PROJECTS_QUERY_KEYS } from "./queryKeys";

export function useProjectDocumentsQuery(projectID: string | undefined) {
  return useQuery({
    queryKey: PROJECTS_QUERY_KEYS.documents(projectID!),
    queryFn: processResponse(() => getProjectsProjectIDDocuments(projectID!)),
    enabled: !!projectID,
  });
}
